import { BoardingCheckListService } from '../../services';
import { LoggerService } from '../../services';
import { OrganisationsService } from '../../services';
import { TaggedLogger } from '../../services';
import { UserService } from '../../services';
import { getCombinedParameters } from '../../utils/getCombinedParameters';
import { tryParseInt } from '../../utils/tryParseInt';
import { IUser } from '../../interfaces/user';
import { IPageResult } from '../../interfaces/page-result';

import { LazyLoadEvent, ConfirmationService, Message, Table, DragDropModule } from 'primeng';
import { IUserFilter } from '../../interfaces/user-filter';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'users',
  templateUrl: 'users.component.html',
  styleUrls: ['./users.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [UserService, ConfirmationService],
})
export class UsersComponent implements OnInit {
  private readonly logger: TaggedLogger;
  private readonly engineiususer_text = 'engineius-user';
  public backTo: string;
  public isActiveCheckList: boolean = false;

  public page: IPageResult<IUser>;

  public filter: Subject<IUserFilter>;
  public filterVal: IUserFilter;
  public orgTypeId: number;
  public hideImpersonateButton: boolean = true;
  public enableImpersonateButton: boolean = false;
  public orgId: number;
  public selectedUser: IUser;
  public currentOrg: any = {};
  public isLoading = false;

  private canImpersonate(): boolean {
    let user = this.userService.currentUser;
    if (!user) return false;
    let roles = ['MANG', 'AADM', 'FINC', 'ACCM'];

    return user.roles.filter((x) => x.isBelong && roles.indexOf(x.name) !== -1).length > 0;
  }

  public canReset2FA(): boolean {
    let user = this.userService.currentUser;
    if (!user) return false;
    let roles = ['POAD'];

    return user.roles.filter((x) => x.isBelong && roles.indexOf(x.name) !== -1).length > 0;
  }

  constructor(
    private userService: UserService,
    private orgService: OrganisationsService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private http: HttpClient,
    private boardingCheckListService: BoardingCheckListService,
    loggerService: LoggerService,
  ) {
    this.logger = loggerService.taggedLogger('component:user');
  }

  ngOnInit() {
    getCombinedParameters(this.route).subscribe((params) => {
      this.logger.debug('params:', params);
      this.backTo = params['backTo'];
      this.orgId = tryParseInt(params['orgId']) as number;
      this.orgTypeId = tryParseInt(params['orgTypeId']) as number;

      this.boardingCheckListService
        .GetBoardingCheckList()
        .then((x) => {
          if (x) {
            this.isActiveCheckList = !x.isHide;
          }
        })
        .catch();

      if (this.orgId || this.orgId === 0) {
        this.logger.debug('Getting org:', this.orgId);
        this.orgService.getOrg(this.orgId).then((res) => {
          this.currentOrg = res;
        });
      } else {
        this.userService.getCurrentUserOrg().then((res) => {
          this.logger.debug('current org:', res);
          this.orgId = res.id;
          this.currentOrg = res;
        });
      }

      this.initDefaultFilter();

      this.filter = new Subject<IUserFilter>();
      this.filter.pipe(debounceTime(500)).subscribe((f) => this.load(f));
      this.filter.next(this.filterVal);
    });
  }

  highlight() {
    this.hideImpersonateButton = true;

    if (this.canImpersonate()) {
      this.hideImpersonateButton = false;

      this.logger.debug('SELECTED USER ' + this.selectedUser.id);

      this.userService.canImpersonate(this.selectedUser.id).then((res: boolean) => {
        this.enableImpersonateButton = res;
      });
    }
  }

  hideImpersonate() {
    this.hideImpersonateButton = true;
  }

  load(filter: IUserFilter) {
    this.isLoading = true;
    if (filter.filters.lockoutEnabled && filter.filters.lockoutEnabled.value == 'null') {
      filter.filters.lockoutEnabled.value = null;
    }

    if (filter.filters.isActive && filter.filters.isActive.value == 'null') {
      filter.filters.isActive.value = null;
    }

    this.userService.getUsersWithRoles(filter).then((result) => {
      this.page = result;
      this.isLoading = false;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'FirstName', // ASC
      sortOrder: 1,
      filters: {
        email: {},
        firstName: {},
        lastName: {},
        lockoutEnabled: { value: null },
        organisationTypeId: { value: this.orgTypeId },
        organisationId: { value: this.orgId },
        isActive: { value: null },
      },
    };
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.logger.debug(this.filterVal);
    this.filter.next(this.filterVal);
  }

  impersonate() {
    var obj = {
      ImpersonatedUserGUID: this.selectedUser.id,
      ImpersonatedUserName: '',
      OriginalUserName: '',
      IsImpersonating: false,
    };
    this.userService.impersonateUser(obj).then((res) => {
      window.location.reload();
    });
  }

  editUser(user: IUser) {
    let userDetailsPage = '';

    if (this.orgTypeId === 1) {
      userDetailsPage = this.router.url.includes(this.engineiususer_text)
        ? 'app/engineius-user-details'
        : 'app/vmeuserdetails';
    } else if (this.orgTypeId === 2) {
      userDetailsPage = 'app/customerdetails';
    } else if (this.orgTypeId === 3) {
      userDetailsPage = 'app/supplierdetails';
    } else if (this.orgTypeId === 5) {
      userDetailsPage = 'app/saasdetails';
    }

    return this.router.navigate([`${userDetailsPage}/${user.id}`], {
      queryParams: { orgTypeId: this.orgTypeId, backTo: this.router.url },
    });
  }

  lockUnlockUser(selectedItem: IUser) {
    var action = selectedItem.isLockedOut ? 'enabled' : 'disabled';
    this.confirmationService.confirm({
      message: `Change user status to be ${action}?`,
      accept: () => {
        this.userService.lockUplock(selectedItem).then((res) => {
          this.load(this.filterVal);
          this.selectedUser = null;
        });
      },
    });
  }

  resetUser2FA(selectedItem: IUser): void {
    this.confirmationService.confirm({
      header: 'Reset 2FA?',
      acceptLabel: 'Continue',
      rejectLabel: 'Cancel',
      message: `Are you sure you want to reset 2FA for ${selectedItem.firstName} ${selectedItem.lastName}?`,
      accept: () => {
        this.userService.reset2FA(selectedItem).then((res) => {
          this.load(this.filterVal);
          this.selectedUser = null;
        });
      },
    });
  }

  addUser() {
    let userDetailsPage = '';

    if (this.orgTypeId === 1) {
      userDetailsPage = this.router.url.includes(this.engineiususer_text)
        ? 'app/engineius-user-details'
        : 'app/vmeuserdetails';
    } else if (this.orgTypeId === 2) {
      userDetailsPage = 'app/customerdetails';
    } else if (this.orgTypeId === 3) {
      userDetailsPage = 'app/supplierdetails';
    } else if (this.orgTypeId === 5) {
      userDetailsPage = 'app/saasdetails';
    }

    const queryParams = { orgTypeId: this.orgTypeId, orgId: this.orgId, backTo: this.router.url };

    return this.router.navigate([userDetailsPage], { queryParams });
  }

  close() {
    if (this.backTo) {
      this.router.navigate([this.backTo]);
    } else if (this.isActiveCheckList) {
      this.router.navigate(['app/']);
    }
  }

  isAdmin = (user) => user.roles.filter((x) => x.name === 'SUPA').length > 0;

  emergencyContact() {
    this.router.navigate([
      `app/emergency-contact/${this.selectedUser.id}`,
      { backTo: this.router.url },
    ]);
  }
}
